import React, { useState } from 'react';
// import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';
import OptionsButton from './Buttons/OptionsButton';
import NotificationMenu from '../components/NotificationMenu';
import ConfirmationDialog from '../components/ConfirmationDialog';
import Snackbar from '../components/Snackbar';
import moment from 'moment';
import { connect } from 'react-redux';
import {
  markedReaded,
  markedFeatured,
  deleteNotification,
  loginUser,
  logoutUser,
  setNotificationRead,
  setNotificationFeatured,
  deleteLawyerNotification,
  changeToCourtesyLawyer
} from '../store/actions/UserAction';
import SwitcherModal from '../layouts/Dashboard/SwitcherModal';
import { showLoading, hideLoading } from '../store/actions/LoadingActions';
import { decryptPassword, doSignInWithEmailAndPassword } from '../configs/environments/firebase/firebaseApp';


const flagFeatured = '/img/marker/flag-featured.svg';
const squareMan = '/img/avatars/square-man.svg';
const squareWoman = '/img/avatars/square-woman.svg';
const squareLogo = '/img/avatars/avatares-cuadro-logo.svg';
const iconMessage = '/img/notifications/chat-1.svg';
const iconOpinion = '/img/notifications/active-star.svg';

const useStyles = makeStyles({
  card: {
    position: 'relative',
    //maxWidth: 680,
    backgroundColor: (props) => (!props.read ? 'rgba(53, 185, 182, 0.1)' : 'white'),
    boxShadow: 'none',
    padding: (props) => props.cardPadding,
    margin: (props) => props.cardMargin,
  },
  cardMobile: {
    position: 'relative',
    backgroundColor: (props) => (!props.read ? 'rgba(53, 185, 182, 0.1)' : 'white'),
    boxShadow: 'none',
    padding: '10px',
    margin: (props) => props.cardMargin,
  },
  featured: {
    position: 'absolute',
    right: (props) => props.featuredPositionRight,
    top: 0,
  },
  title: {
    fontSize: (props) => props.titleFontSize,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#10587f',
  },
  description: {
    fontSize: (props) => props.descriptionFontSize,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#484848',
    margin: (props) => props.descriptionMargin,
  },
  summary: {
    fontSize: (props) => props.descriptionFontSize,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#484848',
  },
  footerText: {
    fontSize: (props) => props.footerFontSize,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#10587f',
  },
  media: (props) => ({
    width: props.mediaWidth,
    height: props.mediaHeight,
    margin: props.mediaMargin,
    overflow: 'hidden',
    fontSize: 0,
    borderRadius: 4,
    border: '1px solid #013957',
    backgroundColor: 'white',
  }),
  mediaImg: {
    width: '100%',
    height: 'auto',
    borderRadius: 34,
  },
  content: {
    padding: '0 !important',
  },
});

const NotificationCard = (props) => {
  const { 
    stateNotifications,
    isDropdown,
    notificationsLaw,
    description,
    summary,
    date,
    uidLawyer,
    //read,
    type,
    featured,
    notification,
    elevation,
    square,
    sender,
    options,
    image,
    notificationUserType,
    handleNotificationClick,
    roleUser,
    uidUser,
    loginUser,
    logoutUser,
    showLoading,
    hideLoading,
    credentialsLawyer,
    setOpenFeedbackMessage,
    setNotificationRead,
    setNotificationFeatured,
    deleteLawyerNotification,
    pageNotifications,
    menuNotifications,
    allNotifications,
    changeToCourtesyLawyer,
   } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [iconNotification, setIconNotifications] = useState()
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [
    notificationWillBeTriggered,
    setOpenNotificationWillBeTriggered,
  ] = useState({
    uid: '',
    read: false,
    featured: false,
  });
  const [switchState, setSwitchState] = useState({
    open: false,
    switchTo: ''
  });
  const [selectedElemInDrop, setSelectedElemInDrop] = useState(roleUser === 'lawFirm' ? 1 : 0);


  const classes = useStyles(props);

  const defaultSender = {
    name: '',
    firstLastName: '',
    secondLastName: '',
    gender: '',
  };
  const { name, firstLastName, secondLastName, gender } =
    sender || defaultSender;

  const handleOpenMenu = (notification) => (event) => {
    //event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setOpenNotificationWillBeTriggered({
      id: notification.uid,
      read: notification.read,
      featured: notification.featured,
    });
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const toggleModalDelete = () => {
    setOpenModalDelete(!openModalDelete);
  };

  

  const handleCloseSwitcher = () => {
    setSwitchState({
      ...switchState,
      open: !switchState,
    })
  }

  const changeToLawfirm = async (values) => {
    try {
        showLoading()
        await logoutUser()
        await loginUser(values.email, values.password, 'lawyeruser')
        hideLoading()
    } catch (error) {
        hideLoading()
        console.log('error', error);
    }
  }

  const changeToLawyer = async () => {
    console.log('ejecuta función')
        try {
            showLoading()
            const data = await decryptPassword({
                email: credentialsLawyer.email,
                password: credentialsLawyer.password
            })
            const { email, password } = data
            await logoutUser()
            // ESTA FUNCIÓN SE LLAMA EN VEZ DEL LOGIN PORQUE EL ABOGADO
            // QUE LE PERTENECE A UN DESPACHO NO PUEDE HACER LOGIN DIRECTO EN EL PORTAL
            const userResponse = await doSignInWithEmailAndPassword(email, password)
            changeToCourtesyLawyer(userResponse)
            hideLoading()
        } catch (error) {
            hideLoading()
            console.log('error', error);
        }
  };

  const idNotifications = notification.idNotifications ? notification.idNotifications : notification.lawyerUid;

  return (
    <>
      <Card
        square={square}
        elevation={elevation}
        className={isDropdown ? classes.cardMobile : classes.card}
      >
        {featured && (
          <img src={flagFeatured} alt="" className={classes.featured} />
        )}
        {isMobile ? (
          <div>
            <div
              className="flexContainer--betweenCenter"
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                if (handleNotificationClick) {

                  if (!notification.read) {
                    setNotificationRead( notification, menuNotifications, pageNotifications.data, allNotifications )
                  }
                  if(notification.lawyerUid  === uidUser){
                    handleNotificationClick(notification.type);
                  }else if(roleUser === 'lawyer'){
                    //change to lawfirm account
                    setSwitchState({
                      open: true,
                      switchTo: 'lawfirm'
                    });
                  }else {
                    //change to premium lawyer account
                    setSwitchState({
                      open: true,
                      switchTo: 'lawyer'
                    });
                  }
                } else if (notificationUserType == 'notificationsClient') {
                  if (!notification.read) {
                    props.markedReaded(
                      notification.uid,
                      notification.read,
                      notificationsLaw,
                      idNotifications,
                      notificationUserType
                    );
                  }
                }
              }}
            >
              <div className="flexContainer--startCenter">
                {/* <figure className={classes.media}> */}
                <div className='content-icon-notifications'>
                <div
                  className={
                    isDropdown ?
                      (
                        notification &&
                        notification.type === "messages" ?
                        "img-type-notification-messageSmall" :
                        'img-type-notification-opinionSmall'
                      ) :
                      (
                        notification &&
                        notification.type === "messages" ?
                        "img-type-notification-message" :
                        'img-type-notification-opinion'
                      )
                  }
                >
                  <div
                    className={
                      isDropdown ?
                      "circle-type-notificationSmall" :
                      "circle-type-notification"
                    }
                  >
                    <img
                      src={
                        isDropdown ?
                        (
                          notification &&
                          notification.role &&
                          notification.role === 'lawyer' ?
                          '/img/notifications/badges/small-profile.svg' :
                          '/img/notifications/badges/small-suitcase.svg'
                        ) :
                        (
                          notification &&
                          notification.role &&
                          notification.role === 'lawyer' ?
                          '/img/notifications/badges/profile.svg' :
                          '/img/notifications/badges/suitcase.svg'
                        )
                      }
                      alt='notification-badge'
                    />
                  </div>
                  </div>
                </div>
                {/* </figure> */}
                <Typography className={classes.title}>{sender}</Typography>
              </div>
              <div
                style={{
                  alignSelf: 'flex-start',
                  //display: !options ? 'none' : 'initial',
                }}
              >
                {notificationUserType && notificationUserType == 'notifications' ? (
                  <OptionsButton
                    onClick={handleOpenMenu({
                      uid: notification.id,
                      read: notification.read,
                      featured: notification.featured,
                    })}
                    style={{ padding: 6, margin: props.optionsButtonMargin }}
                  />
                ) : null}

              </div>

            </div>
            <div className={classes.details}>
              <CardContent className={classes.content}>
                <Typography className={classes.summary}>{summary}</Typography>
                <Typography className={classes.description}>
                  {description}
                </Typography>
                <Typography className={classes.footerText}>

                  {date && moment.unix(date, 'DD-MM-YYYY HH:mm ').fromNow()}

                </Typography>
              </CardContent>
            </div>
          </div>
        ) : (
            <div
              className="flexContainer--betweenCenter"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (handleNotificationClick) {

                  if (!notification.read) {
                    setNotificationRead( notification, menuNotifications, pageNotifications.data, allNotifications )
                  }
                  if(notification.lawyerUid  === uidUser){
                    handleNotificationClick(notification.type);
                  }else if(roleUser === 'lawyer'){
                    //change to lawfirm account
                    setSwitchState({
                      open: true,
                      switchTo: 'lawfirm'
                    });
                  }else {
                    //change to premium lawyer account
                    setSwitchState({
                      open: true,
                      switchTo: 'lawyer'
                    });
                  }
                } else if (notificationUserType == 'notificationsClient') {
                  if (!notification.read) {
                    props.markedReaded(
                      notification.uid,
                      notification.read,
                      notificationsLaw,
                      idNotifications,
                      notificationUserType
                    );
                  }
                }
              }}
            >

              <div className="flexContainer--startCenter">
                {/* <figure className={classes.media}> */}
                <div className='content-icon-notifications'>
                  <div
                    className={
                      isDropdown ?
                        (
                          notification &&
                          notification.type === "messages" ?
                          "img-type-notification-messageSmall" :
                          'img-type-notification-opinionSmall'
                        ) :
                        (
                          notification &&
                          notification.type === "messages" ?
                          "img-type-notification-message" :
                          'img-type-notification-opinion'
                        )
                    }
                  >
                    {notification && notification.role !== undefined && (
                      <div
                        className={
                          isDropdown ?
                          "circle-type-notificationSmall" :
                          "circle-type-notification"
                        }
                      >
                        <img
                          src={
                            isDropdown ?
                            (
                              notification &&
                              notification.role &&
                              notification.role === 'lawyer' ?
                              '/img/notifications/badges/small-profile.svg' :
                              '/img/notifications/badges/small-suitcase.svg'
                            ) :
                            (
                              notification &&
                              notification.role &&
                              notification.role === 'lawyer' ?
                              '/img/notifications/badges/profile.svg' :
                              '/img/notifications/badges/suitcase.svg'
                            )
                          }
                          alt='notification-badge'
                        />
                      {/* <p className="text-type-notification">{notification && notification.role === "lawyer" ? "AB" : "DE" }</p> */}
                      </div>)
                    }
                  </div>
                </div>
                {/* </figure> */}
                <div className={classes.details}>
                  <CardContent className={classes.content}>
                    <Typography className={classes.title}>{sender}</Typography>
                    <Typography className={classes.summary}>{summary}</Typography>
                    <Typography className={classes.description}>
                      {description}
                    </Typography>
                    <Typography className={classes.footerText}>
                      {moment.unix(date, 'DD-MM-YYYY HH:mm ').fromNow()}
                    </Typography>
                  </CardContent>
                </div>
              </div>
              <div
                style={{
                  alignSelf: 'flex-start',
                }}
              >
                {notificationUserType && notificationUserType == 'notifications' ? (
                  <OptionsButton
                    onClick={handleOpenMenu({
                      uid: notification.id,
                      read: notification.read,
                      featured: notification.featured,
                    })}
                    style={{ padding: 6, margin: props.optionsButtonMargin }}
                  />) : null}
              </div>
            </div>
          )}
      </Card>

      <NotificationMenu
        anchorEl={anchorEl}
        read={notificationWillBeTriggered.read}
        featured={notificationWillBeTriggered.featured}
        handleClose={handleCloseMenu}
        markAsRead={() => {
          handleCloseMenu();
          setNotificationRead( notification, menuNotifications, pageNotifications.data, allNotifications )
        }}
        markAsImportant={() => {
          handleCloseMenu();
          setNotificationFeatured( notification, menuNotifications, pageNotifications.data )
        }}
        handleDelete={() => {
          handleCloseMenu();
          toggleModalDelete();
        }}
      />
      <ConfirmationDialog
        title="¿Deseas eliminar esta notificación?"
        subtitle="Se eliminará de tu bandeja de entrada y la información no podrá ser recuperada."
        open={openModalDelete}
        handleClose={toggleModalDelete}
        handleAccept={() => {
          toggleModalDelete();
            deleteLawyerNotification( notification, menuNotifications, pageNotifications.data, allNotifications )
            .then((res) => {
              setOpenFeedbackMessage({
                open: true,
                message: 'La notificación se eliminó exitosamente',
                variant: 'success',
              });
            });
        }}
      />

      <SwitcherModal 
        open={switchState.open} 
        handleClose={handleCloseSwitcher}
        primaryFunction={switchState.switchTo === 'lawyer' ? changeToLawyer : changeToLawfirm}
        setSelectedElemInDrop={setSelectedElemInDrop}
        switchTo = {switchState.switchTo}
      />
    </>
  );
};

const mapStateToProps = state => ({
  credentialsLawyer: state.authClient.credentialsLawyer,
  pageNotifications: state.authClient.notificationsPageLoad,
  menuNotifications: state.authClient.notificationsMenuLoad,
  allNotifications: state.authClient.notificationsLaw,
});

const mapDispatchToProps = (dispatch) => ({
  markedReaded: (id, read, arrayNotify, uidLawyer, notificationUserType) =>
    dispatch(markedReaded(id, read, arrayNotify, uidLawyer, notificationUserType)),
  markedFeatured: (id, featured, arrayNotify, uidLawyer) =>
    dispatch(markedFeatured(id, featured, arrayNotify, uidLawyer)),
  deleteNotification: (uid, arrayNotify, uidLawyer) =>
    dispatch(deleteNotification(uid, arrayNotify, uidLawyer)),
  loginUser: (email, password, roleAuth) => dispatch(loginUser(email, password, roleAuth)),
  logoutUser: () => dispatch(logoutUser()),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
  setNotificationRead: (notification, menuNotifications, pageNotifications, allNotifications) => dispatch(setNotificationRead(notification, menuNotifications, pageNotifications, allNotifications)),
  setNotificationFeatured: (notification, menuNotifications, pageNotifications) => dispatch(setNotificationFeatured(notification, menuNotifications, pageNotifications)),
  deleteLawyerNotification: (notification, menuNotifications, pageNotifications, allNotifications) => dispatch(deleteLawyerNotification(notification, menuNotifications, pageNotifications, allNotifications)),
  changeToCourtesyLawyer: userResponse => dispatch(changeToCourtesyLawyer(userResponse))
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationCard);
